import {createMoment, parseDateString} from 'app/core/helpers/date';

export function formatDate(original: string) {
    const d = parseDateString(original);
    if (!d) {
        return original;
    }
    return formatDateValue(original);
}

export function formatDateValue(date: string | Date) {
    return createMoment(date).format('D MMM YY');
}

export function formatWeek(originalFirstDayOfWeek: string) {
    const d = parseDateString(originalFirstDayOfWeek);
    if (!d) {
        return originalFirstDayOfWeek;
    }
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const date1 = new Date(d.year, d.month - 1, d.day, 12);
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const date2 = new Date(d.year, d.month - 1, d.day + 6, 12);
    return formatDateValue(date1) + ' - ' + formatDateValue(date2);
}

export function formatMonth(originalFirstDayOfMonth: string) {
    const d = parseDateString(originalFirstDayOfMonth);
    if (!d) {
        return originalFirstDayOfMonth;
    }
    return createMoment(originalFirstDayOfMonth).format('MMMM YYYY');
}

export function formatQuarter(originalFirstDayOfQuarter: string) {
    const d = parseDateString(originalFirstDayOfQuarter);
    if (!d) {
        return originalFirstDayOfQuarter;
    }

    return `Q${createMoment(originalFirstDayOfQuarter).quarter()} ${d.year}`;
}
